import _ from 'lodash';

import { prepopulateIntercomMessage } from './chat_helpers';
import { getUsername, getSections } from './user_helpers';
import { getLinkToShopForUsername } from './shop_helpers';

export const getSelectedSpotlightKey = ui => _.get(ui, 'spotlightKey') || null;
export const showingSpotlightTasksModal = ui => _.get(ui, 'spotlightTasksVisible');
export const spotlightKeys = {
  CREATE_PRODUCT_LINK: 'create-link',
  CREATE_SHELF: 'create-shelf',
  CREATE_POST: 'create-post',
  CREATE_CONSULT: 'create-consult',
  CHAT_WITH_BRANDS: 'chat-with-brands',
  CREATE_COLLABORATION: 'create-collaboration',
  RSVP_FOR_EVENTS: 'rsvp',
  SELECT_SHOP_MANAGER: 'select-shop-manager'
};

export const getUrlForSpotlightKey = (key, user) => {
  const username = getUsername(user);
  const sections = getSections(user);
  const shelfSection = sections.find(s => s.previewType === 'shelf');
  const postSection = sections.find(s => s.previewType === 'post');
  const getUrlToSection = section =>
    getLinkToShopForUsername(username, {
      tab: 'collections',
      Section_id: section?.id
    });
  return {
    [spotlightKeys.CREATE_PRODUCT_LINK]: `/links`,
    [spotlightKeys.CREATE_SHELF]: window.__NEW_SHOP_MODE__ ? getUrlToSection(shelfSection) : `/${username}/shelves`,
    [spotlightKeys.CREATE_POST]: window.__NEW_SHOP_MODE__ ? getUrlToSection(postSection) : `/${username}/posts`,
    [spotlightKeys.CHAT_WITH_BRANDS]: `/chat`,
    [spotlightKeys.CREATE_COLLABORATION]: `/collaborations`
  }[key];
};

export const getActionForSpotlightKey = key =>
  ({
    [spotlightKeys.RSVP_FOR_EVENTS]: () => {
      prepopulateIntercomMessage(`Hi! What are some of the upcoming events I can attend?`);
    },
    [spotlightKeys.SELECT_SHOP_MANAGER]: () => {
      prepopulateIntercomMessage(`Hi! Could you assist me in selecting my shop manager?`);
    }
  }[key]);
